import '../../../../public/images/sc-logo-mono-compact.svg';
import '../../../../public/images/sc-logo-mono-full.svg';
import '../../../../public/images/sc-logo-color-compact.svg';
import '../../../../public/images/sc-logo-color-full.svg';

import '../../../../public/images/call-now-color.svg';
import '../../../../public/images/call-now-mono.svg';

import './header-phone-number.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSHeaderPhoneNumber } from './header-phone-number';

components.register({
	selector: '.sc-HeaderPhoneNumber',
	controller: GSHeaderPhoneNumber
});
